/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentEditorCourseFinancialViewModel } from "../types/IndividualPaymentEditorCourseFinancialViewModel.ts";

export const individualPaymentEditorCourseFinancialViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  active: z.optional(z.boolean()),
  description: z.string().nullish(),
  startDate: z.optional(z.string().datetime()),
  endDate: z.string().datetime().nullish(),
  value: z.number().nullish(),
}) as unknown as ToZod<IndividualPaymentEditorCourseFinancialViewModel>;
